import SocialProfile from './SocialProfile'
export default SocialProfile
